import $ from 'jquery';
import getSiteLanguage from './general';
import select2 from 'select2/dist/js/select2.full';
import 'select2/dist/js/i18n/et';
import 'select2/dist/js/i18n/en';
import 'select2/dist/js/i18n/lv';
import 'select2/dist/js/i18n/lt';

/* -------------------------------------------------------------------------- */
/*                       Select2 select element handling                      */
/* -------------------------------------------------------------------------- */
/** This code initializes the select2 library on elements with
 * .select2-multiple and .select2-single classes respectively.
 * They can not be initialized with the same function as they work differently. */
$(function () {
    /** Defines baseline styling options for select2. */
    const baseStyle = {
        language: getSiteLanguage(),
        containerCssClass: ':all:',
        width: '100%'
    };

    // Init multiple option select
    $('.select2-multiple').each(function () {
        $(this).select2(baseStyle);
    });
});
